import ResolveFailedDelivey from "../symbols/resolveFailedDelivery";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

export default function PendingOrdersReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case ResolveFailedDelivey.RESOLVE_FAILED_DELIVERY:
      return { ...state, loading: true, error: false };
    case ResolveFailedDelivey.RESOLVE_FAILED_DELIVERY_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case ResolveFailedDelivey.RESOLVE_FAILED_DELIVERY_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case ResolveFailedDelivey.CLEAR_RESOLVE_FAILED_DELIVERY:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
